
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for/security-engineers",
      function () {
        return require("private-next-pages/for/security-engineers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for/security-engineers"])
      });
    }
  